const initialUserState = {
  userData: []
};

export const createUserSlice = (set) => ({
  ...initialUserState,
  setUserInfo: (userData) => set((state) => ({ ...(state.userData = userData) }))
});
